<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='showAll ? "All Snow Projects" : "Active/Upcoming Snow Projects"'
            :titleIcon='division.icon'
            :titleIconColor='division.iconColor'
            :loading='isLoading'
          >
            <template v-slot:toolbarButtons>
              <v-btn small elevation='0' width='175' color='grey lighten-2' class='mx-1' @click='showAll = !showAll'>
                {{ showAll ? "Show Active Only" : "Show All Projects" }}
              </v-btn>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              dense
              :headers='headers'
              :items='filteredProjects'
              :search='search'
              :items-per-page='25'
              :footer-props='{ "items-per-page-options": [10,15,20,25,-1] }'
              sort-by='name'
              @click:row='openProject'
              :item-class='getItemClass'
            >
              <template v-slot:item.start_date='{ item }'>
                {{ item.start_date | shortDate }}
              </template>
              <template v-slot:item.end_date='{ item }'>
                {{ item.end_date | shortDate }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import projectsAPI from '@/modules/projects/api/projects'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'snow-dashboard',
  data: () => ({
    isLoading: true,
    showAll: false,
    projects: [],
    search: '',
    headers: [
      { text: 'Project Name', value: 'name' },
      { text: 'Number', value: 'number' },
      { text: 'Site Address', value: 'site_address' },
      { text: 'Site City', value: 'site_city' },
      { text: 'Start Date', value: 'start_date', align: 'center' },
      { text: 'End Date', value: 'end_date', align: 'center' }
    ]
  }),
  mounted () {
    this.getProjects()
  },
  computed: {
    division () {
      return this.$store.state.misc.divisions.find(d => d.division_type === 'S')
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    filteredProjects() {
      return this.showAll ? this.projects : this.projects.filter(p => moment(p.end_date).isAfter(this.today) )
    }
  },
  methods: {
    async getProjects () {
      this.isLoading = true
      const div = this.$store.state.misc.divisions.find(d => d.division_type === 'S')
      let tmp = await projectsAPI.getDivisionProjects(div)
      this.projects = _.filter(tmp, p => p.archived == false)
      this.isLoading = false
    },
    openProject (item) {
      this.$router.push({ name: 'SnowOverview', params: { id: item.id } })
    },
    getItemClass (item) {
      return moment(item.end_date).isAfter(this.today) ? "" : "red--text"
    }
  }
}
</script>
